import { Box, Text } from 'braid-design-system';
import { AspectRatioBox } from '../../AspectRatioBox/AspectRatioBox';
import * as styles from './PhotoTile.css';

interface PhotoTileProps {
  link: string;
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export const PhotoTile = ({ link, title, onClick }: PhotoTileProps) => (
  <Box position="relative">
    <AspectRatioBox>
      <Box
        className={styles.imageBox}
        style={{
          backgroundImage: `url(${link})`,
        }}
        borderRadius="large"
      />
    </AspectRatioBox>
    <Box component="button" className={styles.galleryButton} onClick={onClick}>
      <Box className={styles.photoTileOverlayBox} borderRadius="large" />
      <Box
        className={styles.photoTileOverlayText}
        padding="medium"
        background="customDark"
      >
        <Text size="small" weight="medium" align="left">
          {title}
        </Text>
      </Box>
    </Box>
  </Box>
);
